import { z } from 'zod';

export const ComplementaryInsuranceSchema = z.object({
  name: z.string().optional(),
  shortDescription: z.string().optional(),
  longDescription: z.string().optional(),
  amount: z.coerce.number().int().min(0).optional(),
  billingType: z.enum(['perDay', 'perRental']).optional(),
});

export type ComplementaryInsuranceFormData = z.infer<
  typeof ComplementaryInsuranceSchema
>;

export const ExtendedInsuranceSchema = z.object({
  shouldLimitInsurance: z.enum(['true', 'false']).optional(),
  insurances: z.array(ComplementaryInsuranceSchema),
});

export type ExtendedInsuranceFormData = z.infer<typeof ExtendedInsuranceSchema>;
